<template>
  <div class="home">
    <div class="homeBg"></div>
    <video
      class="screensaver"
      autoplay
      muted
      preload
      ref="video"
      @ended="videoEnd()"
      @timeupdate="videoProgress($event)"
      :src="activeVideo"
      playsinline
    ></video>
    <div class="actionBox" v-if="!locked">
      <div
        :key="delivery_method.identifier"
        v-for="delivery_method in activeDeliveryMethods"
        class="actionBg"
        :class="addDeliveryMethodImageCssClass(delivery_method)"
        @click="select(delivery_method, $event)"
      >
        <img v-if="delivery_method.image" :src="delivery_method.image" />

        <video
          v-else-if="delivery_method.video"
          loop
          class="deliveryMethod"
          autoplay
          muted
          preload
          :src="delivery_method.video"
          playsinline
        ></video>

        <div v-else style="display: var(--page_home_actionBg-svg_display)">
          <svg
            v-if="delivery_method.identifier === 'to_take'"
            xmlns="http://www.w3.org/2000/svg"
            height="84px"
            viewBox="0 -960 960 960"
            width="84px"
            fill="var(--page_home_actiontext_color)"
          >
            <path
              d="M222.15-74.02q-27.6 0-47.86-20.27-20.27-20.26-20.27-47.86v-512.83q0-27.7 20.27-48.03 20.26-20.34 47.86-20.34h103.78v-10q.48-64.19 45.14-108.53 44.65-44.34 108.89-44.34 64.24 0 108.93 44.34 44.7 44.34 45.18 108.53v10h103.78q27.7 0 48.03 20.34 20.34 20.33 20.34 48.03v512.83q0 27.6-20.34 47.86-20.33 20.27-48.03 20.27h-515.7Zm0-68.13h515.7v-512.83H634.07v85.94q0 14.42-9.88 24.24-9.87 9.82-24.37 9.82-14.49 0-24.19-9.82-9.7-9.82-9.7-24.24v-85.94H394.07v85.94q0 14.42-9.88 24.24-9.87 9.82-24.37 9.82-14.49 0-24.19-9.82-9.7-9.82-9.7-24.24v-85.94H222.15v512.83Zm172.15-581.2h171.4v-10q-.48-35.61-25.19-60.05-24.71-24.45-60.53-24.45-35.83 0-60.51 24.45-24.69 24.44-25.17 60.05v10Zm-172.15 581.2v-512.83 512.83Z"
            />
          </svg>

          <svg
            v-if="delivery_method.identifier === 'to_stay'"
            xmlns="http://www.w3.org/2000/svg"
            height="84px"
            viewBox="0 -960 960 960"
            width="84px"
            fill="var(--page_home_actiontext_color)"
          >
            <path
              d="m165-120-42-42 420-420q-22-48-10-99.5t57-96.5q45-44 109-56.5T804-806q42 42 28.5 105T772-590q-41 42-91.5 55t-94.5-6l-67 67 312 312-42 42-312-312-312 312Zm125-351L171-590q-51-51-53-121t46-124l245 245-119 119Z"
            />
          </svg>
        </div>

        <div
          class="actionText"
          :class="addDeliveryMethodTextCssClass(delivery_method)"
        >
          {{
            getTranslation(
              $store,
              "DeliveryMethod",
              "display_name",
              delivery_method.id,
              delivery_method.name
            )
          }}
        </div>
      </div>
    </div>
    <div
      class="languageBox languageBox-v2"
      :class="{
        hide: available_languages.length <= 1
      }"
      v-if="!locked && activeDeliveryMethods.length > 0"
    >
      <div class="languageCover">
        <div
          class="languageWrapper"
          v-for="(item, index) in available_languages"
          :key="index"
          :class="{
            activeLang: currentLanguage.code_short == item.code_short
          }"
          @click="changeCurrentLanguage(item)"
        >
          <img
            class="flagStyle"
            :src="`/static/images/flag_${item.code_short}.png`"
          />
          {{ item.code_long }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { checkSchedules } from "@/utils/schedules";
import { getTranslation } from "@/utils/helpers";
import { connect_barcodescanner } from "../api/barcodes";
import { commence_update, connect_deployment } from "../api/deployment";

import { isEmpty } from "lodash";
import { setupRemoteStorageAssortment } from "@/utils/assortment";
import { isCustomHomeEnabled } from "@/utils/templateSettings";

export default {
  data() {
    return {
      currentScreenSaver: 0,
      activeScreenSavers: [],
      locked: false,
      checkSchedulesInterval: 0,
      activeDeliveryMethods: [],
      videoPosition: "",
      lastVideoPosition: null, //must be different!
      videoWatchdogInterval: 0
    };
  },
  computed: {
    ...mapGetters({
      allProducts: "PRODUCTS",
      categories: "CATEGORIES_FILTERED",
      currentLanguage: "CURRENT_LANGUAGE",
      available_languages: "AVAILABLE_LANGUAGES",
      screensavers: "SCREENSAVERS",
      schedules: "SCHEDULES",
      delivery_methods: "DELIVERY_METHODS",
      site_setting: "SITE_SETTING",
      update_required: "UPDATE_REQUIRED",
      kiosk_locked: "LOCKED"
    }),
    isCustomHomeEnabled,
    activeVideo() {
      if (
        this.activeScreenSavers.length > 0 &&
        this.currentScreenSaver >= 0 &&
        this.currentScreenSaver < this.activeScreenSavers.length
      ) {
        return this.activeScreenSavers[this.currentScreenSaver].video;
      }
      return "";
    }
  },
  created() {
    console.log("Home view created");
    this.setPolelight("green");
    this.setDeliveryMethod(null);
    this.setCurrentCategory(null);
    if (this.categories.length === 0) {
      console.log("categories empty, reinitializing...");
      Promise.all([
        this.getCategories(),
        this.getProducts(),
        this.getProductFilters(),
        this.getMenus(),
        this.getPromos(),
        this.getOffers(),
        this.getScreensavers(),
        this.getSchedule(),
        this.getProductAttributes(),
        this.getExtras(),
        this.getDeliveryMethods(),
        this.getSiteSetting(),
        this.getCustomHomeSetting()
      ])
        .finally(this.init)
        .catch(err => {
          console.log(err);
        });
    } else {
      this.init();
    }
  },
  beforeDestroy() {
    clearInterval(this.checkSchedulesInterval);
    clearInterval(this.videoWatchdogInterval);
  },
  methods: {
    addDeliveryMethodTextCssClass(deliveryMethod) {
      return deliveryMethod.image ? "" : "actionText-isBig";
    },
    addDeliveryMethodImageCssClass(deliveryMethod) {
      return deliveryMethod.image ? "" : "actionBg-isBig";
    },
    addDeliveryMethodImage(deliveryMethod) {
      if (deliveryMethod.image) {
        return { "background-image": "url(" + deliveryMethod.image + ")" };
      } else {
        return {
          "background-image": "None"
        };
      }
    },
    getTranslation,
    ...mapMutations({
      setCustomHomeActive: "SET_CUSTOM_HOME_ACTIVE",
      setToTake: "SET_TO_TAKE",
      setDeliveryMethod: "SET_SELECTED_DELIVERY_METHOD",
      setCurrentCategory: "SET_CURRENT_CATEGORY",
      setLanguage: "SET_LANGUAGE",
      clearCoupons: "CLEAR_COUPONS",
      setManualPuck: "SET_MANUAL_PUCK",
      setProducts: "SET_PRODUCTS",
      setSchedule: "SET_SCHEDULE",
      setProductAttributes: "SET_PRODUCT_ATTRIBUTES"
    }),
    ...mapActions({
      getCategories: "GET_CATEGORIES",
      getProducts: "GET_PRODUCTS",
      getProductFilters: "GET_PRODUCT_FILTERS",
      getMenus: "GET_MENUS",
      getPromos: "GET_PROMOS",
      getOffers: "GET_OFFERS",
      logAudit: "LOG_AUDIT",
      logRouter: "LOG_ROUTER",
      getScreensavers: "GET_SCREENSAVERS",
      getSchedule: "GET_SCHEDULE",
      getProductAttributes: "GET_PRODUCT_ATTRIBUTES",
      getExtras: "GET_EXTRAS",
      getDeliveryMethods: "GET_DELIVERY_METHODS",
      getSiteSetting: "GET_SITE_SETTING",
      getCustomHomeSetting: "GET_CUSTOM_HOME_SETTING",
      setPolelight: "SET_POLELIGHT"
    }),
    init() {
      if (isCustomHomeEnabled()) {
        this.setCustomHomeActive(true);
      }
      this.intervalCheck();
      this.setManualPuck(null);
      this.filterDeliveryMethods();

      if (this.kiosk_locked) {
        this.logRouter({ name: "lock", router: this.$router });
        return;
      }
      if (this.site_setting.default_language) {
        this.setLanguage(this.site_setting.default_language);
      }
      this.activeScreenSavers = this.screensavers.filter(item =>
        checkSchedules(this.schedules, item)
      );
      this.currentScreenSaver = 0;
      this.clearCoupons();
      if (this.isScanEnabled()) {
        connect_barcodescanner();
        if (this.activeDeliveryMethods.length == 1) {
          this.setDeliveryMethod(this.activeDeliveryMethods[0].id);
        }
      }
      if (
        this.site_setting.is_orderkiosk ||
        isEmpty(this.site_setting) ||
        process.env.NODE_ENV === "development"
      ) {
        connect_deployment();
      }
      if (this.update_required) {
        this.doUpdate();
      }
      this.addIntervalChecks();
      setupRemoteStorageAssortment(
        this.allProducts,
        this.setProducts,
        this.$store
      ).then(result => {
        if (result) {
          console.log("Remote Storage Assortment setup complete");
        }
      });
    },
    isScanEnabled() {
      return (
        this.site_setting.coupons_enabled ||
        this.site_setting.scan_and_go_enabled ||
        this.site_setting.toilet_voucher_enabled
      );
    },
    doUpdate() {
      console.log("Locking and Updating...");
      this.locked = true;
      commence_update();
    },
    toMenu() {
      if (this.locked) return;
      this.logRouter({ name: "menu", router: this.$router });
    },
    logPageOpen(data) {
      this.logAudit({
        category: "PAGE",
        event: "OPEN",
        data
      });
    },
    select(delivery_method, event) {
      event.target.classList.add("anim");
      //TODO: Remove legacy deliverymethod
      if (delivery_method.identifier === "to_stay") {
        this.setToTake(false);
      } else {
        this.setToTake(true);
      }
      this.setDeliveryMethod(delivery_method.id);
      this.logPageOpen(delivery_method.identifier);
      setTimeout(this.toMenu, 200);
    },
    changeCurrentLanguage(lang) {
      this.setLanguage(lang);
    },
    videoEnd() {
      let old_screensaver = this.currentScreenSaver;
      if (this.activeScreenSavers) {
        this.currentScreenSaver =
          (this.currentScreenSaver + 1) % this.activeScreenSavers.length;
      }
      if (
        this.$refs.video &&
        (this.$refs.video.paused || this.$refs.video.ended)
      ) {
        if (old_screensaver !== this.currentScreenSaver)
          this.$refs.video.src = this.activeVideo;
        //same video as before just hit play again!
        this.$refs.video
          .play()
          .then(() => {
            console.log("playing");
          })
          .catch(error => {
            console.log("not playing because:", error);
          });
      }
    },
    videoProgress(e) {
      if (e.type === "timeupdate") {
        this.videoPosition = this.currentScreenSaver + "-" + e.timeStamp;
      }
    },
    addIntervalChecks() {
      this.checkSchedulesInterval = setInterval(() => {
        this.intervalCheck();
      }, 10000);
      this.videoWatchdogInterval = setInterval(() => {
        if (this.videoPosition === this.lastVideoPosition) {
          this.currentScreenSaver = -1;
          this.videoEnd();
          this.lastVideoPosition = null;
        }
        this.lastVideoPosition = this.videoPosition;
      }, 2000);
    },
    intervalCheck() {
      this.filterScreensavers();
      this.filterDeliveryMethods();
      // added to force reactivity of anything which depends on schedules
      this.setSchedule({ ...this.schedules });
    },
    filterDeliveryMethods() {
      //called every 10 seconds
      this.activeDeliveryMethods = this.delivery_methods.filter(item =>
        checkSchedules(this.schedules, item)
      );
    },
    filterScreensavers() {
      //called every 10 seconds
      this.activeScreenSavers = this.screensavers.filter(item =>
        checkSchedules(this.schedules, item)
      );
    }
  },
  watch: {
    update_required(newVal) {
      if (newVal) {
        this.doUpdate();
      }
    },
    kiosk_locked(newVal) {
      if (newVal) {
        this.logRouter({ name: "lock", router: this.$router });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.homeBg {
  width: 1081px;
  height: 1920px;
  background: var(--page_home_homeBg_background);
  position: absolute;
}
.screensaver {
  position: fixed;
  top: 0;
  left: 0;
  width: 1080px;
  height: 1920px;
  padding: 0;
  margin: 0;
}

.burger {
  position: absolute;
  z-index: 10;
  top: 408px;
  left: -777px;
  width: 2164px;
  height: 1715px;
  background-image: url("~@/assets/img/home.png");
  background-size: cover;
}
.titleBox {
  position: absolute;
  top: -733px;
  left: -192px;
  width: 1452px;
  height: 1452px;
  background: transparent
    linear-gradient(12deg, #fcf7f4 0%, #ffffff 61%, #ffffff 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50%;
  padding-top: 600px;
  padding-left: 192px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.titleText {
  color: #f39a00;
  text-transform: uppercase;
  font-size: 145px;
  margin-left: 180px;
}
.titleTextBlack {
  color: rgb(28, 28, 28);
  text-transform: uppercase;
  font-size: 145px;
  margin-left: 412px;
  margin-top: -30px;
}
.actionBox {
  top: var(--page_home_actiontext_position_top);
  position: absolute;
  z-index: 20;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.actionBg {
  background-position: center 45px;
  background-repeat: no-repeat;
  background-size: 92px 70px;
  background-color: var(--page_home_actionBg_background-color);
  width: var(--page_home_actiontext_width);
  height: var(--page_home_actiontext_height);
  border-radius: var(--page_home_actiontext_border-radius);
  text-transform: var(--page_home_actiontext_text-transform);
  display: flex;
  justify-content: center;
  gap: var(--page_home_actionBg_gap);
  align-items: center;
  flex-direction: column;
  transform-origin: 50% 50%;
  &-isBig {
    justify-content: center;
  }
  img {
    width: 100%;
    height: 84px;
    object-fit: contain;
  }
  padding: 30px;
}
.actionText {
  pointer-events: none;
  font-family: var(--page_home_actionText_font-family);
  font-size: var(--page_home_actionText_font-size);
  letter-spacing: var(--page_home_actionText_letter-spacing);
  padding: var(--page_home_actionText_padding);
  &-isBig {
    font-size: var(--page_home_actionText_big_font-size);
    padding: var(--page_home_actionText-isBig_padding);
  }

  text-align: center;
  color: var(--page_home_actiontext_color);
}

.languageBox {
  top: 1844px;
  position: absolute;
  z-index: 20;
  width: 100%;
  display: flex;
  justify-content: center;
}

.languageBox-v2 {
  align-items: center;
  background: var(--page_home_languageBox-v2-background);
  bottom: 0;
  height: 135px;
  position: fixed;
  top: unset;
  .languageWrapper {
    text-transform: none;
  }
}

.languageBox.hide {
  display: none;
}

.languageWrapper {
  align-items: center;
  background-color: #252525;
  color: #fff;
  display: flex;
  font-size: var(--page_home_languageWrapper-font-size);
  font-family: var(--page_home_languageWrapper-font-family);
  height: 38px;
  justify-content: flex-start;
  margin: 0 10px;
  min-width: 190px;
  outline: var(--app_button-outlined_border-width) solid transparent;
  padding: 10px;
  text-transform: uppercase;
}

.languageCover {
  width: 80%;
  display: flex;
  justify-content: center;
}

.flagStyle {
  height: 22px;
  margin-right: 10px;
}

.activeLang {
  outline: var(--app_button-outlined_border-width) solid #fff;
}

@keyframes animScale {
  40% {
    transform: scale(0.9);
  }
  70% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes animColor {
  40% {
    filter: brightness(80%);
  }
  70% {
    filter: brightness(110%);
  }
  100% {
    filter: brightness(100%);
  }
}

.anim div {
  animation: animScale 300ms 1;
}

.anim {
  animation: animColor 300ms 1;
}
</style>
